import React from "react";
import "./Experience.css";
import ReactCardCarousel from "react-card-carousel";

export const Experience = () => {
  return (
    <div className="gpt3__slider-container" id="Skills">
      <h1>Some of my Skills</h1>

      <div className="gpt3__slider ">
        <ReactCardCarousel
          autoplay={true}
          autoplay_speed={6000}
          spread={"wide"}
          disable_box_shadow={true}
        >
          <div className="gpt3__card">
            <div className="gpt3__card_icon">
              <img
                src="https://img.icons8.com/color/96/000000/javascript--v1.png"
                alt="javascript"
              />
            </div>
            <div className="gpt3__card_desc">
              <h3>Vanilla Javascript</h3>
            </div>
            <div className="gpt3__card_desc-p">
              <p>
                DOM manipulation, implemeting business logics and solving
                differnet problems
              </p>
            </div>
          </div>

          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/color/96/000000/nodejs.png"
                alt="node js"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Node JS</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Javascript Runtime environment for backend implementation using
                javascript and express Js library
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/ios-filled/100/000000/next.png"
                alt="next"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Next JS</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                React js library supporting server-side rendering for fast
                experience
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/carbon-copy/100/000000/api-settings.png"
                alt="rest API"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>REST API</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Designing and implementing fast and powerful API for different
                functions
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/clouds/100/000000/react.png"
                alt="react js"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>React JS</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Frontend javascript library, for creating powerful websites and
                mobile apps
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/color/96/000000/azure-1.png"
                alt="microsoft azure"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Microsoft Azure</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Cloud computing technology, for on-demand computing power
                leasing
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/wired/128/000000/docker.png"
                alt="docker container"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Docker container</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Bundling software packages for easy deployment and sharing on
                different machines
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/color/96/000000/kubernetes.png"
                alt="kubernetes orchestration"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Kubernetes</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Docker Container orchestration for version controls and high
                availability
              </p>
            </div>
          </div>
          <div className="gpt3__card">
            <div className="gpt3__mobileCards-card_icon">
              <img
                src="https://img.icons8.com/color/144/000000/jenkins.png"
                alt="jenkins"
              />
            </div>
            <div className="gpt3__mobileCards-card_desc">
              <h3>Jenkins Pipelines</h3>
            </div>
            <div className="gpt3__mobileCards-card_desc-p">
              <p>
                Creating Continuos Deployment & Integration pipelines for fast
                deployment
              </p>
            </div>
          </div>
        </ReactCardCarousel>
      </div>
      <div className="gpt3__mobileCards">
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/color/48/000000/javascript--v1.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Vanilla Javascript</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              DOM manipulation, implemeting business logics and solving
              differnet problems
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/ios/48/000000/api-settings.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>REST API</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Designing and implementing fast and powerful API for different
              functions
            </p>
          </div>
        </div>

        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/fluency/48/000000/node-js.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Node JS</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Javascript Runtime environment for backend implementation using
              javascript and express Js library
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/dotty/48/000000/react.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>React JS</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Frontend javascript library, for creating powerful websites and
              mobile apps
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img
              src="https://img.icons8.com/ios-filled/48/000000/next.png"
              alt=""
            />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Next JS</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              React js library supporting server-side rendering for fast
              experience
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/color/48/000000/azure-1.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Microsoft Azure</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Cloud computing technology, for on-demand computing power leasing
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/wired/48/000000/docker.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Docker container</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Bundling software packages for easy deployment and sharing on
              different machines
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/ios/50/000000/kubernetes.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Kubernetes</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Docker Container orchestration for version controls and high
              availability
            </p>
          </div>
        </div>
        <div className="gpt3__mobileCards-card">
          <div className="gpt3__mobileCards-card_icon">
            <img src="https://img.icons8.com/ios-filled/50/000000/jenkins.png" />
          </div>
          <div className="gpt3__mobileCards-card_desc">
            <h3>Jenkins Pipelines</h3>
          </div>
          <div className="gpt3__mobileCards-card_desc-p">
            <p>
              Creating Continuos Deployment & Integration pipelines for fast
              deployment
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
